import React, { useState } from 'react';
import Header from '../components/Header';
import PacchettoCardDemo from '../components/PacchettoCardDemo';

const C = {
  trasporto: '#EB1C24',
  alloggio: '#0071BA',
  attivita: '#FF5B00',
  servizi: '#009045',
  dark: '#0a1628',
  white: '#ffffff',
  text: '#1a1a2e',
  textLight: '#6b7280',
  border: '#e0e4ea',
  light: '#f5f7fa',
};

export default function PacchettoDemo() {
  const [copiato, setCopiato] = useState(false);
  const [preferito, setPreferito] = useState(false);

  const handleCondividi = async () => {
    const url = window.location.href;
    if (navigator.share) {
      try { await navigator.share({ title: 'Madrid - OCTA', url }); } catch (_) {}
    } else {
      await navigator.clipboard.writeText(url);
      setCopiato(true);
      setTimeout(() => setCopiato(false), 2000);
    }
  };

  return (
    <div style={{ minHeight: '100vh', backgroundColor: C.light, fontFamily: 'Roboto, sans-serif', color: C.text }}>
      <style>{`
        * { box-sizing: border-box; margin: 0; padding: 0; }
        button { cursor: pointer; font-family: 'Roboto', sans-serif; }
        button:hover { opacity: 0.85; }
        a { font-family: 'Roboto', sans-serif; }
        .octa-hamburger { display: none; }
        .pkt-grid { display: grid; grid-template-columns: 1fr 1fr; }
        .pkt-cell-tl { border-right: 2px solid ${C.border}; border-bottom: 2px solid ${C.border}; min-height: 0; }
        .pkt-cell-tr { border-bottom: 2px solid ${C.border}; min-height: 0; }
        .pkt-cell-bl { border-right: 2px solid ${C.border}; min-height: 0; }
        .pkt-cell-br { min-height: 0; }
        @media (max-width: 1024px) {
          .octa-header-pk { padding: 12px 24px !important; }
          .pkt-main { padding: 32px 24px 60px !important; }
        }
        @media (max-width: 768px) {
          .octa-hamburger { display: flex !important; align-items: center; }
          .octa-header-pk { padding: 12px 16px !important; }
          .octa-nav-link { display: none !important; }
          .pkt-main { padding: 24px 12px 60px !important; }
          .pkt-cell-tl, .pkt-cell-tr, .pkt-cell-bl, .pkt-cell-br { padding: 14px 10px !important; }
          .pkt-actionbar { flex-wrap: wrap !important; gap: 10px !important; }
          .pkt-header-row { flex-direction: column !important; gap: 8px !important; align-items: flex-start !important; }
          .pkt-header-price { font-size: 28px !important; }
          .pkt-dest { font-size: 32px !important; }
          .pkt-flight-row { flex-wrap: wrap !important; gap: 4px !important; }
        }
        @media (max-width: 480px) {
          .pkt-grid { grid-template-columns: 1fr !important; }
          .pkt-cell-tl { border-right: none !important; }
          .pkt-cell-bl { border-right: none !important; border-bottom: 2px solid ${C.border} !important; }
          .pkt-mondo { display: none !important; }
        }
      `}</style>

      <Header bg={C.dark} />

      {/* MAIN */}
      <main className="pkt-main" style={{ maxWidth: '980px', margin: '0 auto', padding: '40px 20px 60px' }}>

        <a href="/bacheca" style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', color: C.textLight, textDecoration: 'none', fontSize: '13px', marginBottom: '24px', fontWeight: 600 }}>
          ← Bacheca
        </a>

        {/* CARD */}
        <div style={{ backgroundColor: C.white, borderRadius: '16px', overflow: 'hidden', boxShadow: '0 6px 36px rgba(0,0,0,0.12)', border: `1px solid ${C.border}` }}>

          {/* ACTION BAR */}
          <div className="pkt-actionbar" style={{ padding: '14px 24px', display: 'flex', alignItems: 'center', gap: '12px', borderBottom: `2px solid ${C.border}` }}>
            <button
              onClick={() => setPreferito(p => !p)}
              style={{ background: 'none', border: 'none', fontSize: '26px', padding: '0 4px', lineHeight: 1, color: preferito ? '#f59e0b' : '#d1d5db' }}
              title="Salva tra i preferiti"
            >
              ★
            </button>
            <div style={{ marginLeft: 'auto', display: 'flex', gap: '12px' }}>
              <a href="/crea" style={{ padding: '10px 24px', borderRadius: '8px', backgroundColor: C.dark, color: C.white, fontSize: '13px', fontWeight: 800, textDecoration: 'none', letterSpacing: '0.04em', display: 'inline-block' }}>
                COPIA / MODIFICA
              </a>
              <button onClick={handleCondividi} style={{ padding: '10px 24px', borderRadius: '8px', backgroundColor: C.dark, color: C.white, fontSize: '13px', fontWeight: 800, border: 'none', letterSpacing: '0.04em' }}>
                {copiato ? 'LINK COPIATO ✓' : 'CONDIVIDI'}
              </button>
            </div>
          </div>

          <PacchettoCardDemo />

        </div>
      </main>

      {/* FOOTER */}
      <footer style={{ padding: '32px 40px', borderTop: `1px solid rgba(255,255,255,0.08)`, display: 'flex', alignItems: 'center', justifyContent: 'space-between', backgroundColor: C.dark, flexWrap: 'wrap', gap: '16px' }}>
        <img src="/images/logo_bianco.png" alt="OCTA" style={{ height: '32px', objectFit: 'contain' }} />
        <p style={{ fontSize: '13px', color: 'rgba(255,255,255,0.4)' }}>© 2025 OCTA — Online Complete Travel Agency</p>
        <div style={{ display: 'flex', gap: '8px' }}>
          {['trasporto', 'alloggio', 'attivita', 'servizi'].map(k => (
            <span key={k} style={{ width: '12px', height: '12px', borderRadius: '50%', display: 'inline-block', backgroundColor: C[k] }} />
          ))}
        </div>
      </footer>
    </div>
  );
}

